//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPromiseLike = (v: any): v is PromiseLike<unknown> => {
  return (
    v instanceof Promise ||
    (v &&
      (typeof v === 'object' || typeof v === 'function') &&
      typeof v.then === 'function')
  );
};
